import { Offer_OfferGroups as groups } from "./backend"


const getGroups = async (hd) => {
    let { data } =  await groups({ groups: hd });
    return data;
}

export default {
    getGroups
}